import { FormattedMessage } from "react-intl";

export type SubscriptionPlanFeaturesPlan = {
  max_services?: number | null;
  max_staff?: number | null;
  max_offline_booking_staff?: number | null;
  enable_growth_statistics?: number | null;
  enable_appointment_cancellation?: number | null;
};

const limitDisplay = (v: number | null | undefined) => {
  if (v == null) {
    return (
      <FormattedMessage id="subscription_feature_unlimited" defaultMessage="Unlimited" />
    );
  }
  return <>{v}</>;
};

const flagEnabled = (v: number | null | undefined) =>
  v === 1 ? (
    <FormattedMessage id="subscription_feature_yes" defaultMessage="Yes" />
  ) : (
    <FormattedMessage id="subscription_feature_no" defaultMessage="No" />
  );

type Props = {
  plan: SubscriptionPlanFeaturesPlan;
  /** e.g. "mb-0" in overview, "mb-3" above a card button */
  listClassName?: string;
  titleClassName?: string;
};

/**
 * Shared list: max services/staff/offline staff + growth stats + cancellation flags.
 */
const SubscriptionPlanFeaturesList = ({
  plan,
  listClassName = "mb-0",
  titleClassName = "h6 mb-2",
}: Props) => {
  return (
    <>
      <h3 className={titleClassName}>
        <FormattedMessage
          id="subscription_features_title"
          defaultMessage="Plan features"
        />
      </h3>
      <ul className={`list-unstyled small ${listClassName}`}>
        <li className="mb-1">
          <strong>
            <FormattedMessage id="subscription_feat_max_services" defaultMessage="Max services" />:
          </strong>{" "}
          {limitDisplay(plan.max_services)}
        </li>
        <li className="mb-1">
          <strong>
            <FormattedMessage id="subscription_feat_max_staff" defaultMessage="Max staff" />:
          </strong>{" "}
          {limitDisplay(plan.max_staff)}
        </li>
        <li className="mb-1">
          <strong>
            <FormattedMessage
              id="subscription_feat_max_offline_booking_staff"
              defaultMessage="Max offline booking staff"
            />
            :
          </strong>{" "}
          {limitDisplay(plan.max_offline_booking_staff)}
        </li>
        <li className="mb-1">
          <strong>
            <FormattedMessage
              id="subscription_feat_growth_stats"
              defaultMessage="Growth statistics"
            />
            :
          </strong>{" "}
          {flagEnabled(plan.enable_growth_statistics)}
        </li>
        <li className="mb-0">
          <strong>
            <FormattedMessage
              id="subscription_feat_appointment_cancel"
              defaultMessage="Appointment cancellation"
            />
            :
          </strong>{" "}
          {flagEnabled(plan.enable_appointment_cancellation)}
        </li>
      </ul>
    </>
  );
};

export default SubscriptionPlanFeaturesList;
